import Button from 'components/Button';
import Error from 'components/form/Error';
import Input from 'components/form/Inputs/Input';
import ArrowRightIcon from 'components/icons/ArrowRight';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { getLocaleDate } from 'utils/time';
import { ButtonsContainer, InputContainer } from '.';
import { MentoringContext } from '..';
import ChangeReferee from './ChangeReferee';

const Accepted: FC = () => {
  const { mentorship } = useContext(MentoringContext);
  const [interruptLoading, setInterruptLoading] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleInterrupt = () => {
    setInterruptLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'INTERRUPTED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setInterruptLoading(false);
      });
  };

  const handleFinish = () => {
    setFinishLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'FINISHED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setFinishLoading(false);
      });
  };

  return (
    <div>
      <InputContainer>
        <Input
          value={mentorship?.createdAt && getLocaleDate(mentorship?.createdAt)}
          readOnly
          variant="disabled"
          label="Début du mentorat"
        />
        <p>Mentor actuel</p>
        <Link
          to={`/admin/mentoring/mentors/${mentorship?.mentor?.id}/mentoring/ongoing/`}
        >
          <Input
            style={{ cursor: 'pointer' }}
            value={
              mentorship?.mentor?.firstName + ' ' + mentorship?.mentor?.lastName
            }
            icon={<ArrowRightIcon />}
            iconSide="right"
            readOnly
          />
        </Link>
        <ChangeReferee mentorship={mentorship} />
      </InputContainer>
      <ButtonsContainer>
        <Button
          color="primary"
          variant="filled"
          onClick={handleInterrupt}
          loading={interruptLoading}
        >
          Interrompre le mentorat
        </Button>
        <Button
          color="primary"
          variant="filled"
          onClick={handleFinish}
          loading={finishLoading}
        >
          Terminer le mentorat
        </Button>
      </ButtonsContainer>
      {error && <Error>Une erreur est survenue.</Error>}
    </div>
  );
};

export default Accepted;
